import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./dashlogs.css";
import "../subjects/style.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import BurdCrumbs from "../../components/burdCrumbs";
import TableLayout from "../../components/table";
import Modal from "../../components/modal";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import { Loader, Toggle } from "rsuite";
import { ChevDown, backIcon } from "../../assets/svgIcons";
import { BASE_URL } from "../../constants";
import { userData } from "../../data/fake_login_data";
import { dashLogsData, logsDetails } from "./data";
import PageHeader from "../../components/page-header";
const DeviceLogs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const univ_id = location?.state?.university_id;
  const [searchHeaderKet, setSearchHeaderKey] = useState("");
  const [physical, setPhysical] = useState("all");
  const [installation, setIntallation] = useState("all");
  const [IsSecure, setIsSecure] = useState("all");
  const [SimCard, setSimCard] = useState("all");
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(false);

  const headers2 = [
    {
      label: "log_id",
      dataIndex: "log_id",
      sort: true,
      // search: true,
    },

    // {
    //   label: "Admin Name",
    //   dataIndex: "user_name",
    //   sort: true,
    //   search: true,
    // },

    {
      label: "student_id",
      dataIndex: "student_id",
      sort: true,
      search: true,
    },

    {
      label: "student_name",
      dataIndex: "student_name",
      sort: true,
      search: true,
    },
    {
      label: "student_phone",
      dataIndex: "student_phone",
      sort: true,
      search: true,
    },
    {
      label: "type",
      dataIndex: "type",
      sort: true,
      search: true,
    },
    {
      label: "skip_sim_card",
      dataIndex: "sim_card",
      type: "children",
      children: ({ row }) => {
        row.sim_card = row?.sim_card == 0 ? 0 : 1;
        return row?.sim_card == 0 ? "No" : "Yes";
      },
      sort: true,
      // search: true,
    },
    {
      label: "sim",
      dataIndex: "sim",
      sort: true,
      search: true,
    },
    {
      label: "known",
      dataIndex: "known",
      children: ({ row }) => {
        return row?.known;
      },
      // sort: true,
      // search: true,
    },
    {
      label: "isSecure",
      dataIndex: "isSecure",
      children: ({ row }) => {
        return row?.isSecure;
      },
      // sort: true,
      // search: true,
    },
    {
      label: "physical",
      dataIndex: "physical",
      children: ({ row }) => {
        return !row?.physical;
      },
      // sort: true,
      // search: true,
    },
    {
      label: "Date & Time",
      dataIndex: "date",
      sort: true,
      search: true,
    },
    {
      label: "Profile",
      type: "children",
      children: ({ row }) => {
        return (
          <a
            className="btn btn-primary"
            href={"/profile?stu_id=" + row?.student_id}
            style={{ textDecoration: "none" }}
            target="_blanck"
          >
            Show Profile
          </a>
        );
      },
      // sort: true,
      // search: true,
    },
  ];
  /*{
  "log_id": "34",
  "student_id": "7391",
  "physical": "1",
  "known": "1",
  "isSecure": "1",
  "sim": "--",
  "date": "2023-12-26 16:46:01",
};*/
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        BASE_URL + "logs/select_device_logs.php",
        {
          physical: physical,
          known: installation,
          isSecure: IsSecure,
          sim: SimCard,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );

      setData(response?.data?.message);
      setLoading(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <div className="childs">
            <PageHeader

title={"Logs"}
description="Manage Logs information and settings"
exportButton={true
}

data={data}

/>
            <div className="log_login">
              
            </div>
            <div className="modern-filter-container">
              <div className="filter-header">
                <h3>Device Filters</h3>
                <p>Customize your search criteria</p>
              </div>
              
              <div className="filters-grid">
                <div className="filter-card">
                  <div className="filter-card-header">
                    <div className="filter-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <h4>Physical Device</h4>
                    <div className="filter-toggle-container">
                      <span className={`toggle-label ${physical === "all" ? "active" : ""}`}>All</span>
                      <Toggle
                        checked={physical == "all"}
                        onChange={(e) => setPhysical(e ? "all" : "Special")}
                        className="modern-toggle"
                      />
                      <span className={`toggle-label ${physical !== "all" ? "active" : ""}`}>Specific</span>
                    </div>
                  </div>
                  
                  {physical != "all" && (
                    <div className="filter-options">
                      <div className="radio-group">
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Physical"
                            value="yes"
                            checked={physical === "yes"}
                            onChange={(e) => setPhysical("yes")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">Yes</span>
                        </label>
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Physical"
                            value="no"
                            checked={physical === "no"}
                            onChange={(e) => setPhysical("no")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">No</span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                <div className="filter-card">
                  <div className="filter-card-header">
                    <div className="filter-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                      </svg>
                    </div>
                    <h4>Installation Source</h4>
                    <div className="filter-toggle-container">
                      <span className={`toggle-label ${installation === "all" ? "active" : ""}`}>All</span>
                      <Toggle
                        checked={installation == "all"}
                        onChange={(e) => setIntallation(e ? "all" : "Special")}
                        className="modern-toggle"
                      />
                      <span className={`toggle-label ${installation !== "all" ? "active" : ""}`}>Specific</span>
                    </div>
                  </div>
                  
                  {installation != "all" && (
                    <div className="filter-options">
                      <div className="radio-group">
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Installation"
                            value="yes"
                            checked={installation === "yes"}
                            onChange={(e) => setIntallation("yes")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">Yes</span>
                        </label>
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Installation"
                            value="no"
                            checked={installation === "no"}
                            onChange={(e) => setIntallation("no")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">No</span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                <div className="filter-card">
                  <div className="filter-card-header">
                    <div className="filter-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
                      </svg>
                    </div>
                    <h4>Security Status</h4>
                    <div className="filter-toggle-container">
                      <span className={`toggle-label ${IsSecure === "all" ? "active" : ""}`}>All</span>
                      <Toggle
                        checked={IsSecure == "all"}
                        onChange={(e) => setIsSecure(e ? "all" : "Special")}
                        className="modern-toggle"
                      />
                      <span className={`toggle-label ${IsSecure !== "all" ? "active" : ""}`}>Specific</span>
                    </div>
                  </div>
                  
                  {IsSecure != "all" && (
                    <div className="filter-options">
                      <div className="radio-group">
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="isSecure"
                            value="yes"
                            checked={IsSecure === "yes"}
                            onChange={(e) => setIsSecure("yes")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">Secure</span>
                        </label>
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="isSecure"
                            value="no"
                            checked={IsSecure === "no"}
                            onChange={(e) => setIsSecure("no")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">Not Secure</span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                <div className="filter-card">
                  <div className="filter-card-header">
                    <div className="filter-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                      </svg>
                    </div>
                    <h4>SIM Card Status</h4>
                    <div className="filter-toggle-container">
                      <span className={`toggle-label ${SimCard === "all" ? "active" : ""}`}>All</span>
                      <Toggle
                        checked={SimCard == "all"}
                        onChange={(e) => setSimCard(e ? "all" : "Special")}
                        className="modern-toggle"
                      />
                      <span className={`toggle-label ${SimCard !== "all" ? "active" : ""}`}>Specific</span>
                    </div>
                  </div>
                  
                  {SimCard != "all" && (
                    <div className="filter-options">
                      <div className="radio-group">
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Simcard"
                            value="yes"
                            checked={SimCard === "yes"}
                            onChange={(e) => setSimCard("yes")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">Has SIM</span>
                        </label>
                        <label className="radio-option">
                          <input
                            type="radio"
                            name="Simcard"
                            value="no"
                            checked={SimCard === "no"}
                            onChange={(e) => setSimCard("no")}
                          />
                          <span className="radio-custom"></span>
                          <span className="radio-label">No SIM</span>
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="search-button-container">
              <button
                className="modern-search-btn"
                onClick={() => (loading ? null : fetchData())}
                disabled={loading}
              >
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner"></div>
                    <span>Searching...</span>
                  </div>
                ) : (
                  <div className="button-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>
                    <span>Search Devices</span>
                  </div>
                )}
              </button>
            </div>
            <TableLayout
              searchHeaderKet={searchHeaderKet}
              headers={headers2}
              data={data}
            />
          </div>
        }
      />
    </div>
  );
};

export default DeviceLogs;
